import { ReactElement } from 'react'

import { type SvgIconName } from '@tribeplatform/react-ui-kit/Icon'

export type CommandBarActionType = {
  name: string
  url?: string
  action?: (props?: unknown) => void
  icon?: SvgIconName | ReactElement | string
  category?: string
  hotkey?: string
}

export const emptyCommandBarResult = {
  actions: [],
  isLoading: false,
}

export type CommandBarHookResult = (options?: { query?: string }) => {
  actions: CommandBarActionType[]
}
